import { defineStore } from "pinia";
import { useMoveStore } from "./DocumentManager/Move";
import { useMultiSelect } from "./DocumentManager/MultiSelect";
import { useDownloadStore } from "./DocumentManager/Download";
import { useDeleteStore } from "./DocumentManager/Delete";
import { useTrashStore } from "./DocumentManager/Trash";

export const piniaPlugin = defineStore("piniaPlugin", () => ({
    useMoveStore: useMoveStore(),
    useMultiSelect: useMultiSelect(),
    useDownloadStore: useDownloadStore(),
    useDeleteStore: useDeleteStore(),
    useTrashStore: useTrashStore(),
}));
